// Regras de CEP do cadastro de endereço do Novo Pedido.

export const soDigitos = (v) => String(v || "").replace(/\D/g, "");

/** "38200000" → "38200-000"; aceita parcial enquanto digita. */
export function mascararCep(v) {
  const d = soDigitos(v).slice(0, 8);
  return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
}

/**
 * CEP único = todos os bairros cadastrados com o mesmo CEP (cidade pequena com
 * um CEP só). Mesma regra do cardápio público e da tela de Bairros.
 */
export function cepUnicoDosBairros(bairros) {
  const lista = Array.isArray(bairros) ? bairros : [];
  if (lista.length === 0) return "";
  const primeiro = soDigitos(lista[0].cep);
  if (primeiro.length !== 8) return "";
  return lista.every((b) => soDigitos(b.cep) === primeiro) ? mascararCep(primeiro) : "";
}

export const nomeDoBairro = (b) => b?.nome || b?.name || "";

export const taxaDoBairro = (b) =>
  parseFloat(b?.valor_entrega ?? b?.taxa_entrega ?? b?.taxa ?? b?.valor ?? 0) || 0;

const normalizar = (s) =>
  String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").trim().toLowerCase();

/** Bairro cadastrado pelo CEP (quando cada bairro tem o seu) ou pelo nome vindo do ViaCEP. */
export function acharBairro(bairros, { cep, nome }) {
  const lista = Array.isArray(bairros) ? bairros : [];
  const d = soDigitos(cep);
  if (d.length === 8) {
    const porCep = lista.filter((b) => soDigitos(b.cep) === d);
    if (porCep.length === 1) return porCep[0];
  }
  if (nome) return lista.find((b) => normalizar(nomeDoBairro(b)) === normalizar(nome)) || null;
  return null;
}

/** Consulta o ViaCEP (o mesmo serviço dos dados da empresa). null = não encontrado ou sem rede. */
export async function consultarCep(cep) {
  const d = soDigitos(cep);
  if (d.length !== 8) return null;
  try {
    const r = await fetch(`https://viacep.com.br/ws/${d}/json/`);
    const j = await r.json();
    return j && !j.erro ? { rua: j.logradouro || "", bairro: j.bairro || "" } : null;
  } catch (_) {
    return null;
  }
}
